module.exports = __webpack_public_path__ + "img/5_35.b50d892a.png";